/*
* Description: Static Application Information
*
* History:
*   01/18/2022  A Kuprion ITMFG-27821 Initial version, needed because package.json can no longer be read
*
**/
export const appinfo = {
    'name': 'brilliant',
    'version': '1.0.0'
}